import { useTranslation } from 'react-i18next';

export const ChargePointsLastMessageHeader = (): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <>{t('delmonicos-shared-sdk.outputs-charge-point.last-heartbeat-time')}</>
  );
};
